var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1333 49.9077C3.1333 48.9412 3.9168 48.1577 4.8833 48.1577H51.55C52.5165 48.1577 53.3 48.9412 53.3 49.9077C53.3 50.8742 52.5165 51.6577 51.55 51.6577H4.8833C3.9168 51.6577 3.1333 50.8742 3.1333 49.9077Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8833 32.991C11.5611 32.991 11.3 33.2522 11.3 33.5743V47.5743C11.3 47.8965 11.5611 48.1577 11.8833 48.1577H16.55C16.8721 48.1577 17.1333 47.8965 17.1333 47.5743V33.5743C17.1333 33.2522 16.8721 32.991 16.55 32.991H11.8833ZM7.79997 33.5743C7.79997 31.3192 9.62814 29.491 11.8833 29.491H16.55C18.8051 29.491 20.6333 31.3192 20.6333 33.5743V47.5743C20.6333 49.8295 18.8051 51.6577 16.55 51.6577H11.8833C9.62814 51.6577 7.79997 49.8295 7.79997 47.5743V33.5743Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4666 40.5743C12.4666 39.6078 13.2501 38.8243 14.2166 38.8243H15.3833C16.3498 38.8243 17.1333 39.6078 17.1333 40.5743C17.1333 41.5408 16.3498 42.3243 15.3833 42.3243H14.2166C13.2501 42.3243 12.4666 41.5408 12.4666 40.5743Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2166 7.32434C20.8945 7.32434 20.6333 7.58551 20.6333 7.90767V47.5743C20.6333 47.8965 20.8945 48.1577 21.2166 48.1577H44.55C44.8721 48.1577 45.1333 47.8965 45.1333 47.5743V7.90767C45.1333 7.58551 44.8721 7.32434 44.55 7.32434H21.2166ZM17.1333 7.90767C17.1333 5.65251 18.9615 3.82434 21.2166 3.82434H44.55C46.8051 3.82434 48.6333 5.65251 48.6333 7.90767V47.5743C48.6333 49.8295 46.8051 51.6577 44.55 51.6577H21.2166C18.9615 51.6577 17.1333 49.8295 17.1333 47.5743V7.90767Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.55 12.5743H25.8833V17.241H30.55V12.5743Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8833 12.5743H35.2166V17.241H39.8833V12.5743Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.55 20.741H25.8833V25.4077H30.55V20.741Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8833 20.741H35.2166V25.4077H39.8833V20.741Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8833 28.9077H35.2166V33.5743H39.8833V28.9077Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8833 37.0743H35.2166V41.741H39.8833V37.0743Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.aac06ea5.svg";
export { ForwardRef as ReactComponent };